import React from 'react';
import styled from 'styled-components';
import { getThemeProp } from 'theme';

const bigLogoImgPath = require('styles/images/Logo-Conversation-Studio-big.svg');
const smallLogoImgPath = require('styles/images/Logo-Conversation-Studio-small.svg');

interface Props {
  isOpen?: boolean;
}

const closedLogoStyles = (props: Props) =>
  !props.isOpen &&
  `
    width: ${getThemeProp('sidebar.variants.closed.width', props)};

    img {
      padding-left: 9px;
    }
  `;

const SContainer = styled.div`
  width: ${getThemeProp('sidebar.width')};

  img {
    padding-left: 18px;
  }

  ${closedLogoStyles}
`;

const bigImg = (
  <img
    alt="Conversation Studio logo"
    data-test="big-logo-image"
    src={bigLogoImgPath}
  />
);

const smallImg = (
  <img
    alt="Conversation Studio logo"
    data-test="small-logo-image"
    src={smallLogoImgPath}
  />
);

const Logo = ({ isOpen = false }: Props) => (
  <SContainer isOpen={isOpen}>{isOpen ? bigImg : smallImg}</SContainer>
);

export default Logo;
